<!-- 
  选择套餐
  lovi 2020-07-08
 -->
<template>
  <div class="childRoute-wrapper">
    <van-nav-bar
      class="gradient"
      :title="$t('recharge.dataPackage')"
      left-arrow
      :fixed="true"
      @click-left="navBarBack"
    >
    </van-nav-bar>
    <div class="scroll-wrapper">
      <div class="bg"></div>
      <div class="combo">
        <h3 class="title">{{ $t("recharge.packageDays") }}</h3>
        <van-tabs class="top-nav" v-model="comboTitle">
          <van-tab
            :title="item.day + $t('common.days')"
            v-for="(item, index) in comboList"
            :key="index"
          >
            <h3 class="title">{{ $t("recharge.dataPackage") }}</h3>
            <scroll ref="scroll">
              <van-cell-group>
                <van-cell
                  :title="combo.content"
                  :value="combo.amount + 'P'"
                  v-for="(combo, comboIndex) in item.list"
                  :key="comboIndex"
                  @click="chooseCombo(combo)"
                />
              </van-cell-group>
            </scroll>
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    comboFlag: {
      //显示隐藏
      type: Boolean,
      default: function() {
        return true;
      }
    },
    operatorId: {
      //类型
      type: Number,
      default: function() {
        return 0;
      }
    }
  },
  components: {},
  data() {
    return {
      comboTitle: 0,
      comboIndex: -1,
      comboList: []
    };
  },
  created() {
    this.getCallsDataDenomination();
  },
  mounted() {},
  computed: {},
  methods: {
    navBarBack() {
      // 返回事件
      this.$emit("update:comboFlag", false);
    },
    chooseCombo(data) {
      //选择套餐
      let vm = this;
      vm.$emit("getComboInfo", data);
    },
    getCallsDataDenomination() {
      //流量充值面板
      let vm = this;
      let params = {};
      params.operator_id = vm.operatorId;
      vm.$post("/app/recharge/callsDataDenomination", params, {
        loading: true
      }).then(res => {
        console.log("callsDataDenomination", res);
        vm.comboList = res.denomination;
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
@imgUrl: "~@/assets/images/";
.scroll-wrapper {
  background: #f4f4f4;
  .bg {
    height: 50px;
    background: linear-gradient(90deg, #2043ac, #130f73);
  }
}
.combo {
  background: #fff;
  border-radius: 8px;
  position: absolute;
  left: 16px;
  top: 16px;
  right: 16px;
  bottom: 16px;
  .title {
    padding: 0 16px;
    padding-top: 12px;
    font-size: 16px;
    font-weight: 400;
  }
  /deep/.van-tabs {
    &.top-nav {
      position: absolute;
      top: 33px;
      left: 0;
      right: 0;
      bottom: 0;
      .van-tabs__wrap {
        height: 44px;
        padding: 0 16px;
        &.van-tabs__nav--line {
          padding-bottom: 0;
        }
        .van-tabs__nav {
          .van-tab {
            min-width: 54px;
            flex: initial;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0;
            .van-tab__text {
              display: flex;
              align-items: center;
              justify-content: center;
              line-height: initial;
              min-width: 54px;
              height: 24px;
              color: #9b9b9b;
              font-size: 14px;
              border-radius: 5px;
            }
          }
          .van-tab--active {
            .van-tab__text {
              background: linear-gradient(
                90deg,
                rgba(32, 67, 172, 1) 0%,
                rgba(19, 15, 115, 1) 100%
              );
              color: #fff;
            }
          }
          .van-tabs__line {
            display: none;
          }
        }
      }
      .van-tabs__content {
        height: calc(100% - 44px);
        background: url("@{imgUrl}combo/pic_eepay.png") no-repeat right bottom;
        background-size: 270px;
        .title {
          padding: 6px 16px;
        }
        .van-tab__pane {
          height: calc(100%);
          position: relative;
        }
        .list-wrapper {
          top: 33px;
          background: none;
          .van-cell-group {
            background: none;
          }
          .van-cell {
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: none;
            &::after {
              left: 0;
            }
            .van-cell__title {
              margin-right: 10px;
              font-size: 14px;
              display: flex;
              align-items: center;
              line-height: 1.3;
            }
            .van-cell__value {
              flex: initial;
              color: #fe7800;
              font-size: 16px;
              font-weight: 500;
            }
          }
        }
      }
    }
  }
}
</style>
